import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class GGSoundConfig implements ISoundConfig {

    public static instance: GGSoundConfig = new GGSoundConfig();

    static AS_WIN: string = "asWin";
    static AS_WIN_BIG: string = "asWinBig";
    static BIG_WIN_LEVELS: string[] = ["bigwinLevel1", "bigwinLevel2", "bigwinLevel3", "bigwinLevel4", "bigwinLevel5"];
    static BIG_WIN_END: string = "bigwinEnds";
    static TINY_WIN: string = "countupEndsTiny";
    static SMALL_WIN: string = "countupEndsSmall";
    static MEDIUM_WIN: string = "countupEndsMedium";
    static LARGE_WIN: string = "countupEndsLarge";
    static COUNTUP: string = "countup";
    static GOBLIN_POPUP: string = "trollsUp";
    static GOBLIN_THROW: string = "throwBomb";
    static GOBLIN_ANTICIPATION_SHORT: string = "trollAnticipationShort";
    static GOBLIN_ANTICIPATION_LONG: string = "trollAnticipationLong";
    static GOBLIN_TO_SKELETON: string = "trollToSkeleton";
    static EVEL4_LAND_ON_REEL1: string = "evil4Reel1Landing";
    static EVEL4_MULTIPLIER_UPDATE: string = "evil4MultiplierUpdate";
    static LAST_TWO_GOBLIN_START_EVIL4: string[] = ["trollsUpVoiceM1", "trollsUpVoiceM2", "trollsUpVoiceM3", "trollsUpVoiceM4", "trollsUpVoiceM5"];
    static LAST_GOBLIN_START_EVIL4: string[] = ["trollsUpM1", "trollsUpM2", "trollsUpM3", "trollsUpM4", "trollsUpM5"];
    static SYMBOL_WIN_ROW_0: string = "winRow1";
    static SYMBOL_WIN_ROW_1: string = "winRow2";
    //On the sign
    static BOMB_MULTIPLIER: string = "multiplierUpgrade";
    //On the bomb
    static BOMB_ADD_MULTIPLIER: string = "xbombMultiplier";
    //+1 on scatter when landed in fs
    static FS_PLUS: string = "fsPlusSpins";
    //Upgrade from normak
    static EVIL4_BLAST: string = "trollHighlight";
    static EVIL4_POPUP: string = "trollChair";
    static MToWild: string = "wildBombHit";
    static DEADWILD_LANDING: string = "deadWildLanding";
    static DEADWILD_LANDING_2: string = "deadWildLanding2";
    static DEADWILD_LANDING_WIN: string = "deadWildLandingWin";
    static SYMBOL_WIN_EXPLOSIONS: string[] = ["winExplosionSingle1", "winExplosionSingle2", "winExplosionSingle3", "winExplosionSingle4", "winExplosionSingle2", "winExplosionSingle4"];
    static SYMBOL_SMALL_WIN_EXPLOSIONS: string[] = ["winExplosionMany1", "winExplosionMany2"];
    static BOMB_THROW_MANY: string = "throwExplosionMany";
    static BOMB_THROW_ONE: string = "throwExplosionSingle";
    static BOMB_THROW_HIGHLIGHT: string = "throwExplosionHighlight";
    static ANTICIPATION: string = "anticipation";
    static ANTICIPATION_END: string = "anticipationEnds";
    static ANTICIPATION_FAIL: string = "anticipationFails";
    static SCATTER_1: string = "scatter1";
    static SCATTER_2: string = "scatter2";
    static SCATTER_3: string = "scatter3";
    static SCATTER_4: string = "scatter4";
    static BOMB_LANDING: string = "xbombLanding";
    static BOMB_EXPLODE: string = "xbombExplode";
    static SCATTER_WIN: string = "scatterWin";
    static WIN_ROW_M: string = "winRowMidSym";
    static ANTICIPATION_SYMBOL_LANDING: string = "anticipationSymbolLanding";
    static ANTICIPATION_SYMBOL_LANDING_MULTI: string = "anticipationSymbolsLanding";
    static LUCKY_DRAW: string = "randomBuy";
    static FS_COUNTER_UPDATE: string = "fsSpinCounterUpdate";
    static FS_BUTTON_CLICK: string = "continueButton";
    static FS_INTRO_NORMAL: string = "fsIntroFMS";
    static FS_INTRO_NORMAL_BOMB: string = "fsIntroEFMS";
    static FS_INTRO_SUPER: string = "fsIntroGFS";
    static FS_INTRO_SUPER_BOMB: string = "fsIntroEGFS";
    static FS_INTRO_XBOMB: string = "fsIntroxBomb";
    static FS_OUTRO_WIN: string = "fsEndsGood";
    static FS_OUTRO_NO_WIN: string = "fsEndsBad";
    static FS_Camera_Panning: string = "cameraPanning";
    static GFS_RETRIGGER: string = "voiceRetrigger";
    static CAP_WIN_START: string = "capWinStart";
    static CAP_WIN_LOOP: string = "capWinMusicLoop";
    static CAP_WIN_CONTINUE: string = "capWinContinue";
    // REELS_SPINNING_START_ON_SPIN_START:string = "reelsSpinOut";
    static REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6", "reelLanding7", "reelLanding8", "reelLanding9", "reelLanding10", "reelLanding11"];
    MAIN_GAME_AMBIANCE: string = "background-music-main";
    FREE_SPIN_AMBIANCE: string = "background-music-fs";
    SUPER_FREE_SPIN_AMBIANCE: string = "background-music-super-fs";

    // REELS_SPIN_START?:string[];
    // REELS_SPINNING:string = "reelsSpinning";
    //static WILD_WIN:string = "wildWin";
    DEADWILD_GW: string = "deadWildToGold";
    // REELS_DEFAULT_STOP?:string[];
    REEL_SPIN_OUT: string = "reelsSpinOut";
    REEL_SPIN_IN: string = "reelsSpinIn";

    constructor() {
        if (GGSoundConfig.instance) {
            throw new Error("GGSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}